import { ITagsView, ITagsViewState } from '@/types/app';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import trim from '@/utils/trim';

@Module({ namespaced: true, name: 'tagsView' })
export default class TagsView extends VuexModule implements ITagsViewState {
  views: ITagsView[] = [];

  @Mutation
  private ADD_VIEW(view: ITagsView) {
    if (this.views.some(v => trim(v.path, '/') === trim(view.path, '/'))) {
      return;
    }
    this.views.push({ ...view });
  }

  @Mutation
  private DEL_VIEW(view: ITagsView) {
    for (const [i, v] of this.views.entries()) {
      if (v.path === view.path) {
        this.views.splice(i, 1);
        break;
      }
    }
  }

  @Mutation
  private DEL_OTHERS_VIEWS(view: ITagsView) {
    this.views = this.views.filter(v => v.path === view.path);
  }

  @Mutation
  private DEL_ALL_VIEWS() {
    this.views = [];
  }

  @Mutation
  private UPDATE_VIEW(view: ITagsView) {
    for (let v of this.views) {
      if (v.path === view.path) {
        v = Object.assign(v, view);
        break;
      }
    }
  }

  @Action
  addView(view: ITagsView) {
    this.ADD_VIEW(view);
  }

  @Action
  delView(view: ITagsView) {
    return new Promise<ITagsView[]>(resolve => {
      this.DEL_VIEW(view);
      resolve([...this.views]);
    });
  }

  @Action
  delOthersViews(view: ITagsView) {
    return new Promise<ITagsView[]>(resolve => {
      this.DEL_OTHERS_VIEWS(view);
      resolve([...this.views]);
    });
  }

  @Action
  delAllViews() {
    return new Promise<ITagsView[]>(resolve => {
      this.DEL_ALL_VIEWS();
      resolve([...this.views]);
    });
  }

  @Action
  updateView(view: ITagsView) {
    this.UPDATE_VIEW(view);
  }
}
